import {
  useCallback,
  useEffect,
  useRef,
} from 'react';

import useLogger from './useLogger';

const ActionEvent = {
  MEAL_PLAN: 'MEAL_PLAN',
  WORKOUT: 'WORKOUT',
  CHAT: 'CHAT',
  DEFAULT: 'DEFAULT',
};

const useTimeForActionLogger = ({
  actionEvent = ActionEvent.DEFAULT,
  autoStart = true,
  ready = true,
} = {}) => {
  const { logTimeForAction } = useLogger();
  const startTimeRef = useRef(null);

  const markStart = useCallback(() => {
    startTimeRef.current = performance.now();
  }, []);

  useEffect(() => {
    if (autoStart && ready) {
      markStart();
    }
  }, [autoStart, ready, markStart]);

  const logSuccess = useCallback((metadata = {}) => {
    const startTime = startTimeRef.current;
    const completedAt = performance.now();

    if (!startTime) {
      // Ensure we always have a start for future calls
      markStart();
      return;
    }

    logTimeForAction(actionEvent, {
      timeSpentMs: completedAt - startTime,
      ...metadata,
    });
  }, [actionEvent, logTimeForAction, markStart]);

  return {
    markStart,
    logSuccess,
  };
};

export default useTimeForActionLogger;
export { ActionEvent };
